import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";
import { SEOHead } from "@/components/SEOHead";

const SellerProducts = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const { data: shop } = useQuery({
    queryKey: ["my-shop-id", user?.id],
    queryFn: async () => {
      if (!user) return null;
      const { data } = await supabase.from("shops").select("id").eq("owner_id", user.id).maybeSingle();
      return data;
    },
    enabled: !!user,
  });

  const { data: products } = useQuery({
    queryKey: ["my-products", shop?.id],
    queryFn: async () => {
      if (!shop?.id) return [] as any[];
      const { data } = await supabase
        .from("products")
        .select("id, title, price_cents, currency, stock, status")
        .eq("shop_id", shop.id)
        .order("created_at", { ascending: false });
      return data ?? [];
    },
    enabled: !!shop?.id,
  });
  return (
    <main className="container mx-auto px-4 py-10">
      <SEOHead
        title="Manage Products - Bahama Marketplace Seller"
        description="Manage your product listings on Bahama Marketplace. Add, edit, and organize your products to maximize sales."
      />
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-heading font-bold">Your Products</h1>
        <Button onClick={() => navigate("/seller/products/new")}>New Product</Button>
      </div>
      <div className="rounded-xl border p-6">
        {!products?.length ? (
          <div className="text-muted-foreground">No products yet. Create your first one.</div>
        ) : (
          <div className="grid gap-3">
            {products.map((p: any) => (
              <div key={p.id} className="flex items-center justify-between border rounded-lg p-4">
                <div>
                  <div className="font-medium">{p.title}</div>
                  <div className="text-sm text-muted-foreground">{p.currency} {(p.price_cents / 100).toFixed(2)} · Stock {p.stock} · {p.status}</div>
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" onClick={() => navigate(`/products/${p.id}`)}>View</Button>
                  <Button onClick={() => navigate(`/seller/products/${p.id}/edit`)}>Edit</Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default SellerProducts;